// action - state management
// types
import { AuthProps, AuthActionProps } from 'types/auth';

import { REGISTER, LOGIN, LOGOUT } from './actions';

// initial state
export const initialState: AuthProps = {
  isLoggedIn: false,
  isInitialized: false,
  user: null,
  session: false
};

// ==============================|| AUTH REDUCER ||============================== //

const auth = (state = initialState, action: AuthActionProps) => {
  switch (action.type) {
    case REGISTER: {
      const { user } = action.payload!;
      return {
        ...state,
        user
      };
    }

    case LOGIN: {
      const { user } = action.payload!;
      return {
        ...state,
        isLoggedIn: true,
        isInitialized: true,
        user
      };
    }

    case LOGOUT: {
      return {
        ...state,
        isLoggedIn: false,
        user: null,
        session: false
      };
    }

    default: {
      return { ...state };
    }
  }
};

export default auth;
